var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93333 11.9118L7.35583 11.5152C7.48778 11.3905 7.56047 11.2244 7.56047 11.047C7.56047 10.8696 7.48778 10.7034 7.35583 10.5786L2.56934 6.05534L7.36114 1.52685C7.49309 1.40225 7.56567 1.23603 7.56567 1.05868C7.56567 0.881329 7.49309 0.715004 7.36114 0.590309L6.94125 0.193686C6.66819 -0.064562 6.22341 -0.064562 5.95035 0.193686L0.22462 5.58539C0.0927784 5.70999 -0.000115175 5.87602 -0.000115182 6.05494L-0.000115183 6.05701C-0.00011519 6.23446 0.0928824 6.40049 0.22462 6.52509L5.93484 11.9118C6.06668 12.0366 6.24767 12.1051 6.43534 12.1053C6.6231 12.1053 6.8016 12.0366 6.93333 11.9118Z",
    fill: "#003471"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.5a89d1b2f347cf0caf33d18bf70e0ed3.svg";
export { ForwardRef as ReactComponent };